export const getDailyMissionUrl = (baseUrl: string) => {
  const dailyMissionUrl = `${baseUrl}/daily-missions`
  return {
    GET_DAILY_MISSION: (target_date: string) => `${dailyMissionUrl}/date/${target_date}`,
    COMPLETE_TOGGLE: (daily_mission_id: string) => `${dailyMissionUrl}/${daily_mission_id}/toggle-complete`,
    DATE_RANGE: `${dailyMissionUrl}/date-range`
  }
}
